import { render, staticRenderFns } from "./spirit-bottle-11.vue?vue&type=template&id=0be58cba"
import script from "./spirit-bottle-11.vue?vue&type=script&lang=js"
export * from "./spirit-bottle-11.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports